<template>
  <kbd :title="label" class="bk-shortcut">
    <template v-if="meta"> <kbd>CTRL</kbd> + </template>
    <template v-if="shift"> <kbd>SHIFT</kbd> + </template>
    <kbd>{{ keyLabel }}</kbd>
  </kbd>
</template>

<script setup>
import { computed, useBlokkli, onMounted, onBeforeUnmount } from "#imports";
import onBlokkliEvent from "#blokkli/helpers/composables/onBlokkliEvent";
import defineShortcut from "#blokkli/helpers/composables/defineShortcut";
const props = defineProps({
  group: { type: String, required: false },
  viewOnly: { type: Boolean, required: false },
  meta: { type: Boolean, required: false },
  shift: { type: Boolean, required: false },
  keyCode: { type: String, required: true },
  label: { type: String, required: true }
});
const emit = defineEmits(["pressed"]);
const { state } = useBlokkli();
const key = computed(
  () => [props.meta, props.shift, props.keyCode.toLowerCase()].join("-")
);
const keyLabel = computed(() => {
  if (props.keyCode === "Delete") {
    return "\u232B";
  } else if (props.keyCode === "ArrowDown") {
    return "\u2193";
  } else if (props.keyCode === "ArrowUp") {
    return "\u2191";
  } else if (props.keyCode === "ArrowRight") {
    return "\u2192";
  } else if (props.keyCode === "ArrowLeft") {
    return "\u2190";
  } else if (props.keyCode === "Digit0" || props.keyCode === "0") {
    return "\uE07B";
  }
  return props.keyCode.toUpperCase();
});
if (!props.viewOnly) {
  defineShortcut({
    meta: props.meta,
    shift: props.shift,
    code: props.keyCode,
    label: props.label,
    group: props.group
  });
}
onBlokkliEvent("keyPressed", (e) => {
  const checkKey = [e.meta, e.shift, e.code.toLowerCase()].join("-");
  if (key.value !== checkKey) {
    return;
  }
  e.originalEvent.preventDefault();
  if (state.isLoading.value) {
    return;
  }
  emit("pressed");
});
onMounted(() => {
  if (props.viewOnly) {
    return;
  }
});
onBeforeUnmount(() => {
  if (props.viewOnly) {
    return;
  }
});
</script>

<script>
export default {
  name: "ShortcutIndicator"
};
</script>
